// Global quantity selector handler
document.addEventListener("DOMContentLoaded", function () {
  // Find all forms that might have quantity selectors
  const productForms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  productForms.forEach((form) => {
    // Find quantity inputs associated with this form
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`
    );

    if (quantityInputs.length === 0) return;

    // Override form submission
    form.addEventListener("submit", function (e) {
      // Get the first visible quantity input
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;

      // Remove any existing hidden quantity inputs
      form
        .querySelectorAll('input[type="hidden"][name="quantity"]')
        .forEach((input) => {
          input.remove();
        });

      // Create a new hidden input with the current quantity
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;

      // Add the hidden input to the form
      form.appendChild(qtyInput);
    });
  });

  // Handle responsive product titles
  function handleResponsiveProductTitles() {
    const productTitles = document.querySelectorAll(
      ".shop-product-title[data-font-size][data-mobile-font-size]"
    );

    productTitles.forEach((title) => {
      function adjustTitleFontSize() {
        const desktopSize = title.getAttribute("data-font-size");
        const mobileSize = title.getAttribute("data-mobile-font-size");

        if (window.innerWidth <= 767) {
          title.style.setProperty("font-size", `${mobileSize}px`, "important");
        } else {
          title.style.setProperty("font-size", `${desktopSize}px`, "important");
        }
      }

      // Run immediately
      adjustTitleFontSize();

      // Add resize event listener if not already added
      if (!title.hasAttribute("data-resize-listener-added")) {
        window.addEventListener("resize", adjustTitleFontSize);
        title.setAttribute("data-resize-listener-added", "true");
      }
    });
  }

  // Initialize responsive product titles
  handleResponsiveProductTitles();

  // Handle FAQ accordions
  function initFaqAccordions() {
    const faqContainers = document.querySelectorAll(".product-faq");

    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;

      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion =
        innerFaqContainer &&
        innerFaqContainer.getAttribute("data-accordion") === "true";

      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;

        // Only add click listener if it doesn't already have one
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");

          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            // Close all other items first if accordion mode is enabled
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }

            // Toggle the clicked item
            item.classList.toggle("active");
          });
        }
      });
    });
  }

  // Initialize FAQ accordions
  initFaqAccordions();

  // Initialize product gallery functionality
  initProductGallery();
  
  // Listen for variant image changes
  document.addEventListener('variant:imageChanged', function(event) {
    if (event.detail && event.detail.image) {
      updateGalleryWithVariantImage(event.detail.image);
    }
  });
});

// Other product details JavaScript can go here

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
      bar.addEventListener("click", function () {
        // Get pricing values
        const pricingContainer = bar.querySelector(
          ".kaching-bundles__bar-pricing"
        );
        const priceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-price"
        );
        const fullPriceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-full-price"
        );

        const price = priceElement ? priceElement.textContent.trim() : null;
        const fullPrice = fullPriceElement
          ? fullPriceElement.textContent.trim()
          : null;

        // Find parent product info block
        const productInfo = bar.closest(".shop-product-info");

        if (productInfo && price && fullPrice) {
          const buttonTextContainer = productInfo.querySelector(
            ".shop-add-to-cart-button .button-text"
          );
          if (buttonTextContainer) {
            setTimeout(function () {
              buttonTextContainer.innerHTML = `Add to Cart - ${price} <span class="compare-price">${fullPrice}</span>`;
            }, 50);
          }
        }
      });
    });
  }, 1000);
});

function initProductGallery() {
  const mainImages = document.querySelectorAll('.shop-main-image');
  const thumbnails = document.querySelectorAll('.shop-thumbnail');
  const prevArrow = document.querySelector('.shop-prev-arrow');
  const nextArrow = document.querySelector('.shop-next-arrow');

  if (!mainImages.length || !thumbnails.length) return;

  let currentIndex = Array.from(mainImages).findIndex(img => img.classList.contains('active'));
  if (currentIndex === -1) currentIndex = 0;

  function updateArrowStates() {
    if (!prevArrow || !nextArrow) return;
    prevArrow.classList.toggle('disabled', currentIndex === 0);
    nextArrow.classList.toggle('disabled', currentIndex === mainImages.length - 1);
  }

  function changeImage(index) {
    if (index < 0 || index >= mainImages.length) return;

    // Clear all actives
    mainImages.forEach(img => {
      img.classList.remove('active');
      img.style.display = 'none';
    });
    thumbnails.forEach(thumb => thumb.classList.remove('active'));

    // Set active
    mainImages[index].classList.add('active');
    mainImages[index].style.display = 'block';
    thumbnails[index].classList.add('active');

    // Update current index
    currentIndex = index;

    // Keep thumbnail in view
    thumbnails[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

    updateArrowStates();
  }

  // Thumbnail clicks
  thumbnails.forEach((thumb, i) => {
    thumb.addEventListener('click', () => changeImage(i));
  });

  // Arrow clicks
  if (prevArrow) prevArrow.addEventListener('click', () => changeImage(currentIndex - 1));
  if (nextArrow) nextArrow.addEventListener('click', () => changeImage(currentIndex + 1));

  // Init
  changeImage(currentIndex);

  // Expose globally for variant switching
  window.changeImage = changeImage;
}

function updateGalleryWithVariantImage(variantImage) {
  const mainImages = document.querySelectorAll('.shop-main-image');
  const thumbnails = document.querySelectorAll('.shop-thumbnail');

  if (!mainImages.length) return;

  const variantImageUrl = variantImage.src ? variantImage.src.split('?')[0] : '';

  // Replace the first main image with the variant image
  mainImages[0].src = variantImageUrl;
  mainImages[0].dataset.variantId = variantImage.variant_id || '';
  mainImages[0].dataset.mediaId = variantImage.id || '';

  // Replace the first thumbnail too (supporting both <img> and background styles)
  if (thumbnails.length) {
    const thumb = thumbnails[0];

    if (thumb.tagName.toLowerCase() === "img") {
      // Thumbnail is an <img>
      thumb.src = variantImageUrl;
    } else {
      // Thumbnail may have an <img> inside
      const imgInside = thumb.querySelector("img");
      if (imgInside) {
        imgInside.src = variantImageUrl;
      } else {
        // Or it might be styled via background-image
        thumb.style.backgroundImage = `url("${variantImageUrl}")`;
      }
    }
  }

  // Always switch to the first image
  if (typeof window.changeImage === 'function') {
    window.changeImage(0);
  }
}


